import { render, staticRenderFns } from "./verificationCloture.vue?vue&type=template&id=4b037303&"
import script from "./verificationCloture.vue?vue&type=script&lang=js&"
export * from "./verificationCloture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports